/**
 * Gedeelde bevestigingsdialoog (P2, brede analyse 5 sep, FU-15): "verwijderen = bevestiging
 * óf undo-toast". Gebruik via utils/bevestig (imperatief, geen JSX in de aanroeper nodig).
 */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export default function ConfirmDialog({ open, titel, tekst, knop = 'Doorgaan', annuleer = 'Annuleren', gevaarlijk = false, onConfirm, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '0.75rem' } }}
      // Altijd boven een al open dialoog (bv. "Leverancier toevoegen"), ook als die later in de DOM staat.
      sx={{ zIndex: (t) => t.zIndex.modal + 1 }}>
      <DialogTitle sx={{ fontFamily: '"Manrope", system-ui, sans-serif', fontWeight: 800, fontSize: '1rem', pb: 0.5 }}>{titel}</DialogTitle>
      {tekst && (
        <DialogContent sx={{ pt: 0.5 }}>
          <Typography sx={{ fontFamily: '"Inter", system-ui, sans-serif', fontSize: '0.86rem', color: '#526075', whiteSpace: 'pre-line' }}>{tekst}</Typography>
        </DialogContent>
      )}
      <DialogActions sx={{ px: 2.5, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', fontWeight: 600, color: '#526075' }}>{annuleer}</Button>
        <Button onClick={onConfirm} variant="contained" color={gevaarlijk ? 'error' : 'primary'} disableElevation autoFocus
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: '0.5rem' }}>{knop}</Button>
      </DialogActions>
    </Dialog>
  );
}
